import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class PickingServices {
    static currentComponent: any;
}
